import styled, { css } from "styled-components";
import { borderRadius } from "../../../design-system/tokens/borders";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";
import { shadows } from "../../../design-system/tokens/shadows";

/** Figma 2858:215601 — search results panel (inline or portal). */
export const MenuPanel = styled.div<{ $inline?: boolean }>`
  position: ${({ $inline }) => ($inline ? "relative" : "fixed")};
  z-index: ${({ $inline }) => ($inline ? "auto" : 1500)};
  display: flex;
  flex-direction: column;
  align-self: stretch;
  width: ${({ $inline }) => ($inline ? "100%" : "auto")};
  flex: 0 0 auto;
  overflow: hidden;
  background-color: ${rawColors.structural.white};
  border: 1px solid ${rawColors.stroke[200]};
  border-radius: ${borderRadius.xl};
  box-shadow: ${shadows.elevation[3]};
  padding: ${spacing[2]};
  box-sizing: border-box;
`;

const scrollbarStyles = css`
  scrollbar-width: thin;
  scrollbar-color: ${rawColors.stroke[300]} transparent;

  &::-webkit-scrollbar {
    width: 3px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${rawColors.stroke[300]};
    border-radius: ${borderRadius.full};
    border: 0.5px solid ${rawColors.stroke[200]};
  }
`;

export const List = styled.div<{ $maxHeight?: number }>`
  display: flex;
  flex-direction: column;
  gap: ${spacing[1]};
  overflow-y: auto;
  max-height: ${({ $maxHeight }) =>
    $maxHeight != null ? `${$maxHeight / 16}rem` : "none"};
  ${scrollbarStyles}
`;

export const EmptyState = styled.p`
  margin: 0;
  padding: ${spacing[2]} ${spacing[3]} ${spacing[3]};
  ${typographyMixin("caption", 4)}
  color: ${rawColors.text.mediumEmphasis};
`;

export const LoadingState = styled.p`
  margin: 0;
  padding: ${spacing[2]} ${spacing[3]} ${spacing[3]};
  ${typographyMixin("caption", 4)}
  color: ${rawColors.text.lowEmphasis};
`;
